// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sin CSS extra por ahora, usamos Bootstrap 5 utility classes y estilos inline permitidos */
`, "",{"version":3,"sources":["webpack://./src/app/components/shared/setup-2fa-modal/setup-2fa-modal.component.css"],"names":[],"mappings":"AAAA,4FAA4F","sourcesContent":["/* Sin CSS extra por ahora, usamos Bootstrap 5 utility classes y estilos inline permitidos */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
